module.exports = __webpack_public_path__ + "img/bxs_widget.eec09857.svg";